var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56563 1.8344C8.41561 1.68443 8.21216 1.60017 8.00003 1.60017C7.7879 1.60017 7.58446 1.68443 7.43443 1.8344L1.83443 7.4344C1.68871 7.58528 1.60807 7.78737 1.60989 7.99712C1.61172 8.20688 1.69585 8.40753 1.84418 8.55586C1.9925 8.70418 2.19315 8.78832 2.40291 8.79014C2.61267 8.79196 2.81475 8.71133 2.96563 8.5656L3.20003 8.3312V13.6C3.20003 13.8122 3.28432 14.0157 3.43435 14.1657C3.58438 14.3157 3.78786 14.4 4.00003 14.4H5.60003C5.81221 14.4 6.01569 14.3157 6.16572 14.1657C6.31575 14.0157 6.40003 13.8122 6.40003 13.6V12C6.40003 11.7878 6.48432 11.5843 6.63435 11.4343C6.78438 11.2843 6.98786 11.2 7.20003 11.2H8.80003C9.01221 11.2 9.21569 11.2843 9.36572 11.4343C9.51575 11.5843 9.60003 11.7878 9.60003 12V13.6C9.60003 13.8122 9.68432 14.0157 9.83435 14.1657C9.98438 14.3157 10.1879 14.4 10.4 14.4H12C12.2122 14.4 12.4157 14.3157 12.5657 14.1657C12.7157 14.0157 12.8 13.8122 12.8 13.6V8.3312L13.0344 8.5656C13.1853 8.71133 13.3874 8.79196 13.5972 8.79014C13.8069 8.78832 14.0076 8.70418 14.1559 8.55586C14.3042 8.40753 14.3883 8.20688 14.3902 7.99712C14.392 7.78737 14.3114 7.58528 14.1656 7.4344L8.56563 1.8344Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6ffdc2e093310b1696e162234d7e3dc7.svg";
export { ForwardRef as ReactComponent };